import React from 'react';

import './style.scss';

const SwirlIllustrationsHero: React.FC = () => (
  <div className="SwirlIllustrations--Hero" />
);

export default SwirlIllustrationsHero;
